<!-- eslint-disable prettier/prettier -->
<template>
  <!-- <div class="row justify-content-center">
    <div class="col-12">
      <div class="page-title-box d-sm-flex align-items-center justify-content-between">
        <h4 class="mb-sm-0">Rekap Tiket</h4>
      </div>
    </div>
  </div> -->
  <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="timelineModalTitle" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-fullscreen-lg-down modal-dialog-scrollable">
      <div class="modal-content border-0 shadow">
        <div class="modal-header border-0 pb-0 align-items-start">
          <div class="pe-3">
            <h5 class="modal-title fw-semibold mb-1" id="timelineModalTitle">Timeline Tiket</h5>
            <p class="text-muted small mb-0 font-monospace" v-if="op.kodetiket">{{ op.kodetiket }}</p>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Tutup"></button>
        </div>
        <div class="modal-body pt-3">
          <div class="container-fluid px-0 px-sm-2 pb-2">
            <div class="tl-loading d-flex flex-column align-items-center justify-content-center py-5" v-if="loadingApi">
              <div class="spinner-border text-primary mb-3" role="status">
                <span class="visually-hidden">Memuat…</span>
              </div>
              <p class="text-muted small mb-0">Memuat timeline…</p>
            </div>
            <div class="main-timeline-4 tl-timeline-root" v-else>
              <div class="timeline-4 left-4">
                <div class="card tl-card border-0 shadow-sm">
                  <div class="card-header tl-card-header tl-card-header--start border-0 py-3">
                    <div class="d-flex align-items-center gap-2">
                      <span class="tl-step-icon bg-primary text-white"><i class="ri-add-circle-line"
                          aria-hidden="true"></i></span>
                      <div>
                        <span class="tl-badge-step">Langkah 1</span>
                        <h5 class="mb-0 fw-semibold">Tiket dibuat</h5>
                      </div>
                    </div>
                  </div>
                  <div class="card-body pt-0 mt-2">
                    <div class="row g-3 tl-meta-grid">
                      <div class="col-sm-6 col-lg-4">
                        <span class="tl-meta-label">Kode tiket</span>
                        <div class="fw-semibold text-break">{{ op.kodetiket || '—' }}</div>
                      </div>
                      <div class="col-sm-6 col-lg-4">
                        <span class="tl-meta-label">Produk / modul</span>
                        <div class="fw-medium">{{ op.nama_produk || '—' }}</div>
                      </div>
                      <div class="col-sm-6 col-lg-4">
                        <span class="tl-meta-label">Tanggal dibuat</span>
                        <div><i class="ri-calendar-line text-muted me-1" aria-hidden="true"></i>{{ op.tgl_buat || '—' }}
                        </div>
                      </div>
                    </div>
                    <hr class="my-3 opacity-25">
                    <span class="tl-meta-label">Deskripsi</span>
                    <p class="tl-desc text-body mb-0 mt-1">{{ op.deskripsi || '—' }}</p>
                    <div class="mt-3">
                      <span class="tl-meta-label d-block mb-2">Lampiran</span>
                      <div class="tl-attachments rounded-3 bg-light p-3" v-show="op.nama_file !== null">
                        <div class="row g-2">
                          <div class="col-12 col-md-8"
                            v-if="ambilExtension(op.nama_file) == 'jpg' || ambilExtension(op.nama_file) == 'jpeg' || ambilExtension(op.nama_file) == 'png' || ambilExtension(op.nama_file) == 'webp'">
                            <a target="_blank" rel="noopener noreferrer" class="tl-thumb-link"
                              :href="'https://api.vitech.asia/storage/customer/' + op.nama_file">
                              <img :src="'https://api.vitech.asia/storage/customer/' + op.nama_file"
                                alt="Pratinjau lampiran" class="img-fluid rounded-2 tl-thumb" /></a>
                          </div>
                          <div class="col-auto" v-else-if="ambilExtension(op.nama_file) == 'pdf'">
                            <a target="_blank" rel="noopener noreferrer" class="tl-file-link"
                              :href="'https://api.vitech.asia/storage/customer/' + op.nama_file"><img
                                src="/images/pdf.png" alt="Buka PDF" class="tl-file-icon"></a>
                          </div>
                          <div class="col-auto"
                            v-else-if="ambilExtension(op.nama_file) == 'doc' || ambilExtension(op.nama_file) == 'docx'">
                            <a target="_blank" rel="noopener noreferrer" class="tl-file-link"
                              :href="'https://api.vitech.asia/storage/customer/' + op.nama_file"><img
                                src="/images/doc.png" alt="Buka dokumen" class="tl-file-icon"></a>
                          </div>
                          <div class="col-auto"
                            v-else-if="ambilExtension(op.nama_file) == 'xlsx' || ambilExtension(op.nama_file) == 'xls'">
                            <a target="_blank" rel="noopener noreferrer" class="tl-file-link"
                              :href="'https://api.vitech.asia/storage/customer/' + op.nama_file"><img
                                src="/images/xls.png" alt="Buka spreadsheet" class="tl-file-icon"></a>
                          </div>
                          <div class="col-12 col-md-8" v-else>
                            <video class="tl-video rounded-2 w-100" controls>
                              <source :src="'https://api.vitech.asia/storage/customer/' + op.nama_file">
                            </video>
                          </div>
                        </div>
                      </div>
                      <p class="text-muted small mb-0 fst-italic" v-show="op.nama_file === null">Tidak ada lampiran</p>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="timeline-4 right-4">
                  <div class="card tl-card border-0 shadow-sm">
                    <div class="card-header tl-card-header tl-card-header--assign border-0 py-3">
                      <div class="d-flex align-items-center gap-2">
                        <span class="tl-step-icon bg-info text-white"><i class="ri-team-line"
                            aria-hidden="true"></i></span>
                        <div>
                          <span class="tl-badge-step">Langkah 2</span>
                          <h5 class="mb-0 fw-semibold">Penugasan tim</h5>
                        </div>
                      </div>
                    </div>
                    <div class="card-body py-4 text-center text-muted" v-if="!pm || pm.length === 0">
                      <i class="ri-user-unfollow-line fs-1 d-block mb-2 opacity-25" aria-hidden="true"></i>
                      <span class="small">Belum ada penugasan tim.</span>
                    </div>
                    <template v-else>
                      <div class="card-body tl-assign-block pt-0 pb-3" v-for="(assign, pmIdx) in pm"
                        :key="'pm-' + pmIdx">
                        <div class="tl-assign-inner rounded-3 border bg-white p-3 mt-3">
                          <div class="d-flex align-items-start justify-content-between gap-2 flex-wrap mb-2">
                            <div>
                              <span class="tl-meta-label">Tim</span>
                              <div class="fw-semibold"><i class="ri-user-3-line text-primary me-1"
                                  aria-hidden="true"></i>{{ assign.nm_pegawai }}</div>
                            </div>
                          </div>
                          <span class="tl-meta-label">Catatan</span>
                          <div class="tl-catatan small text-body-secondary mt-1 mb-3" v-html="assign.catatan"></div>
                          <span class="tl-meta-label d-block mb-2">Lampiran</span>
                          <div class="tl-attachments rounded-3 bg-light p-2 mb-3" v-show="pmFile !== null">
                            <div v-for="gmbr in splitStringFromArray(pmFile)" :key="gmbr" class="tl-attach-row">
                              <div class="py-2"
                                v-if="ambilExtension(gmbr) == 'jpg' || ambilExtension(gmbr) == 'jpeg' || ambilExtension(gmbr) == 'png'">
                                <a target="_blank" rel="noopener noreferrer" class="tl-thumb-link"
                                  :href="'https://api.vitech.asia/storage/customer/' + gmbr">
                                  <img :src="'https://api.vitech.asia/storage/customer/' + gmbr" alt="Lampiran"
                                    class="img-fluid rounded-2 tl-thumb" /></a>
                              </div>
                              <div class="py-2" v-else-if="ambilExtension(gmbr) == 'pdf'">
                                <a target="_blank" rel="noopener noreferrer" class="tl-file-link"
                                  :href="'https://api.vitech.asia/storage/customer/' + gmbr"><img src="/images/pdf.png"
                                    alt="PDF" class="tl-file-icon"></a>
                              </div>
                              <div class="py-2"
                                v-else-if="ambilExtension(gmbr) == 'doc' || ambilExtension(gmbr) == 'docx'">
                                <a target="_blank" rel="noopener noreferrer" class="tl-file-link"
                                  :href="'https://api.vitech.asia/storage/customer/' + gmbr"><img src="/images/doc.png"
                                    alt="Dokumen" class="tl-file-icon"></a>
                              </div>
                              <div class="py-2"
                                v-else-if="ambilExtension(gmbr) == 'xlsx' || ambilExtension(gmbr) == 'xls'">
                                <a target="_blank" rel="noopener noreferrer" class="tl-file-link"
                                  :href="'https://api.vitech.asia/storage/customer/' + gmbr"><img src="/images/xls.png"
                                    alt="Spreadsheet" class="tl-file-icon"></a>
                              </div>
                              <div class="py-2"
                                v-else-if="ambilExtension(gmbr) == 'mp4' || ambilExtension(gmbr) == 'mov'">
                                <video class="tl-video rounded-2 w-100" controls>
                                  <source :src="'https://api.vitech.asia/storage/customer/' + gmbr">
                                </video>
                              </div>
                              <div class="py-2" v-else>
                                <a target="_blank" rel="noopener noreferrer" class="tl-file-link"
                                  :href="'https://api.vitech.asia/storage/customer/' + gmbr">
                                  <img src="/images/files.png" alt="Unduh file" class="tl-file-icon"></a>
                              </div>
                            </div>
                          </div>
                          <p class="text-muted small mb-3 fst-italic" v-show="pmFile === null">Tidak ada lampiran</p>
                          <div class="row g-2 small">
                            <div class="col-12 col-md-6">
                              <span class="tl-meta-label">Tanggal penugasan</span>
                              <div><i class="ri-calendar-check-line text-info me-1" aria-hidden="true"></i>{{
                                assign.tgl_penugasan_awal }} — {{ assign.tgl_penugasan_akhir }}</div>
                            </div>
                            <div class="col-12 col-md-6">
                              <span class="tl-meta-label">Jam penugasan</span>
                              <div><i class="ri-time-line text-info me-1" aria-hidden="true"></i>{{ assign.jam_awal }} —
                                {{ assign.jam_akhir }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
                <div v-for="(teknis, tekIdx) in tek" :key="'tek-' + tekIdx">
                  <div class="timeline-4 left-4" v-show="teknis.status_pm == 2 || teknis.status_pm == 3">
                    <div class="card tl-card border-0 shadow-sm">
                      <div class="card-header tl-card-header tl-card-header--tech border-0 py-3">
                        <div class="d-flex flex-wrap align-items-center gap-2">
                          <span class="tl-step-icon bg-success text-white"><i class="ri-tools-line"
                              aria-hidden="true"></i></span>
                          <div class="flex-grow-1">
                            <span class="tl-badge-step">Tim teknis</span>
                            <h5 class="mb-0 fw-semibold">Pengerjaan</h5>
                          </div>
                          <span class="badge rounded-pill bg-secondary" v-show="teknis.status_pm == 0">Menunggu tim
                            teknis</span>
                          <span class="badge rounded-pill bg-primary" v-show="teknis.status_pm == 1">Diteruskan ke tim
                            teknis</span>
                          <span class="badge rounded-pill bg-info text-dark" v-show="teknis.status_pm == 2">Sedang
                            dikerjakan</span>
                          <span class="badge rounded-pill bg-success" v-show="teknis.status_pm == 3">Selesai
                            dikerjakan</span>
                        </div>
                      </div>
                      <div class="card-body pb-2">
                        <div class="d-flex align-items-center gap-2 mb-3 pb-2 border-bottom">
                          <i class="ri-user-star-line text-success fs-5" aria-hidden="true"></i>
                          <span class="fw-semibold">{{ teknis.nm_pegawai }}</span>
                        </div>
                        <div class="row g-3">
                          <div class="col-md-6">
                            <span class="tl-meta-label">Status pengerjaan</span>
                            <div v-if="teknis.proses_servis == 1"><span class="badge bg-warning text-dark">Proses
                                perbaikan</span></div>
                            <div v-else-if="teknis.proses_servis == 2"><span class="badge bg-success">Selesai
                                perbaikan</span></div>
                            <div v-else class="text-muted">—</div>
                          </div>
                          <div class="col-md-6">
                            <span class="tl-meta-label">Tanggal pengerjaan</span>
                            <div><i class="ri-calendar-check-line text-muted me-1" aria-hidden="true"></i>{{
                              teknis.tgl_perbaikan_awal || '—' }}</div>
                          </div>
                          <div class="col-12">
                            <span class="tl-meta-label">Keterangan / solusi</span>
                            <p class="tl-desc mb-0 mt-1">{{ teknis.solusi ?? '—' }}</p>
                          </div>
                          <div class="col-12">
                            <span class="tl-meta-label d-block mb-2">Lampiran</span>
                            <div class="tl-attachments rounded-3 bg-light p-3" v-show="teknis.nama_file !== null">
                              <div v-for="gmbr in splitStringFromArray(teknis.nama_file)" :key="gmbr">
                                <div class="row g-2 py-1">
                                  <div class="col-12 col-md-6"
                                    v-if="ambilExtension(gmbr) == 'jpg' || ambilExtension(gmbr) == 'jpeg' || ambilExtension(gmbr) == 'png' || ambilExtension(gmbr) == 'webp'">
                                    <a target="_blank" rel="noopener noreferrer" class="tl-thumb-link"
                                      :href="'https://api.vitech.asia/storage/customer/' + gmbr">
                                      <img
                                        :src="(gmbr != null) ? 'https://api.vitech.asia/storage/customer/' + gmbr : 'images/noimage.png'"
                                        alt="Lampiran" class="img-fluid rounded-2 tl-thumb" />
                                    </a>
                                  </div>
                                  <div class="col-auto" v-else-if="ambilExtension(gmbr) == 'pdf'">
                                    <a target="_blank" rel="noopener noreferrer" class="tl-file-link"
                                      :href="'https://api.vitech.asia/storage/customer/' + gmbr">
                                      <img src="/images/pdf.png" alt="PDF" class="tl-file-icon"></a>
                                  </div>
                                  <div class="col-auto"
                                    v-else-if="ambilExtension(gmbr) == 'doc' || ambilExtension(gmbr) == 'docx'">
                                    <a target="_blank" rel="noopener noreferrer" class="tl-file-link"
                                      :href="'https://api.vitech.asia/storage/customer/' + gmbr">
                                      <img src="/images/doc.png" alt="Dokumen" class="tl-file-icon"></a>
                                  </div>
                                  <div class="col-auto"
                                    v-else-if="ambilExtension(gmbr) == 'xls' || ambilExtension(gmbr) == 'xlsx'">
                                    <a target="_blank" rel="noopener noreferrer" class="tl-file-link"
                                      :href="'https://api.vitech.asia/storage/customer/' + gmbr">
                                      <img src="/images/xls.png" alt="Spreadsheet" class="tl-file-icon"></a>
                                  </div>
                                  <div class="col-12 col-md-8"
                                    v-else-if="ambilExtension(gmbr) == 'mp4' || ambilExtension(gmbr) == 'mov'">
                                    <video class="tl-video rounded-2 w-100" controls>
                                      <source :src="'https://api.vitech.asia/storage/customer/' + gmbr">
                                    </video>
                                  </div>
                                  <div class="col-auto" v-else>
                                    <a target="_blank" rel="noopener noreferrer" class="tl-file-link"
                                      :href="'https://api.vitech.asia/storage/customer/' + gmbr">
                                      <img src="/images/files.png" alt="File" class="tl-file-icon"></a>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <p class="text-muted small mb-0 fst-italic" v-show="teknis.nama_file === null">Tidak ada
                              lampiran</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="op.status == 'closed'">
                <div class="timeline-4 left-4">
                  <div class="card tl-card border-0 shadow-sm tl-card-closed">
                    <div class="card-header tl-card-header border-0 py-3 bg-danger bg-opacity-10">
                      <div class="d-flex align-items-center gap-2">
                        <span class="tl-step-icon bg-danger text-white"><i class="ri-checkbox-circle-line"
                            aria-hidden="true"></i></span>
                        <div>
                          <span class="tl-badge-step text-danger">Penutupan</span>
                          <h5 class="mb-0 fw-semibold">Tiket ditutup</h5>
                          <p class="small text-muted mb-0 mt-1">{{ op.tgl_tutup }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="card-body">
                      <div class="row g-3">
                        <div class="col-12 col-md-6">
                          <span class="tl-meta-label">Pertanyaan</span>
                          <p class="tl-desc mb-0 mt-1">{{ op.pertanyaan || '—' }}</p>
                        </div>
                        <div class="col-12 col-md-6">
                          <span class="tl-meta-label">Jawaban</span>
                          <p class="tl-desc mb-0 mt-1">{{ op.jawaban || '—' }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer border-0 pt-0">
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Tutup</button>
        </div>
      </div>
    </div>
  </div>
  <div class="row justify-content-center g-3 mb-2">
    <div class="col-xl-3 col-md-6 col-sm-12">
      <div class="card card-animate dt-filter-card h-100" role="button" tabindex="0"
        :class="{ 'dt-filter-card--active': status_val === 'all' }" :aria-pressed="status_val === 'all'"
        aria-label="Tampilkan semua tiket" @click="showAll('all')" @keyup.enter="showAll('all')">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-start">
            <div>
              <p class="text-muted mb-1 small text-uppercase fw-semibold letter-spacing-1">Ringkasan</p>
              <h4 class="fw-semibold text-dark mb-0">Semua Tiket</h4>
              <h2 class="mt-3 mb-0 ff-secondary">
                <span class="counter-value badge bg-primary fs-4 px-3 py-2">{{ total_tiket }}</span>
              </h2>
            </div>
            <div class="avatar-sm flex-shrink-0">
              <span class="avatar-title bg-soft-primary text-primary rounded-circle fs-4">
                <i class="ri-ticket-2-line" aria-hidden="true"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-md-6 col-sm-12">
      <div class="card card-animate dt-filter-card h-100" role="button" tabindex="0"
        :class="{ 'dt-filter-card--active': status_val === 'progress' }" :aria-pressed="status_val === 'progress'"
        aria-label="Tampilkan tiket dalam proses" @click="showAll('progress')" @keyup.enter="showAll('progress')">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-start">
            <div>
              <p class="text-muted mb-1 small text-uppercase fw-semibold letter-spacing-1">Sedang jalan</p>
              <h4 class="fw-semibold text-dark mb-0">Tiket Proses</h4>
              <h2 class="mt-3 mb-0 ff-secondary">
                <span class="counter-value badge bg-warning text-dark fs-4 px-3 py-2">{{ pending_tiket }}</span>
              </h2>
            </div>
            <div class="avatar-sm flex-shrink-0">
              <span class="avatar-title bg-soft-warning text-warning rounded-circle fs-4">
                <i class="mdi mdi-timer-sand" aria-hidden="true"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-md-6 col-sm-12">
      <div class="card card-animate dt-filter-card h-100" role="button" tabindex="0"
        :class="{ 'dt-filter-card--active': status_val === 'closed' }" :aria-pressed="status_val === 'closed'"
        aria-label="Tampilkan tiket selesai" @click="showAll('closed')" @keyup.enter="showAll('closed')">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-start">
            <div>
              <p class="text-muted mb-1 small text-uppercase fw-semibold letter-spacing-1">Selesai</p>
              <h4 class="fw-semibold text-dark mb-0">Tiket Selesai</h4>
              <h2 class="mt-3 mb-0 ff-secondary">
                <span class="counter-value badge bg-success fs-4 px-3 py-2">{{ closed_tiket }}</span>
              </h2>
            </div>
            <div class="avatar-sm flex-shrink-0">
              <span class="avatar-title bg-soft-success text-success rounded-circle fs-4">
                <i class="ri-check-double-line" aria-hidden="true"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-md-6 col-sm-12">
      <div class="card card-animate h-100">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-start">
            <div class="flex-grow-1">
              <p class="text-muted mb-1 small text-uppercase fw-semibold letter-spacing-1">Kuota</p>
              <h4 class="fw-semibold text-dark mb-3">Mandays</h4>
              <div class="dt-md-metric">
                <span class="dt-md-metric__label">MD. Billable</span>
                <span class="dt-md-metric__value">{{ mdBillable }}</span>
              </div>
              <div class="dt-md-metric">
                <span class="dt-md-metric__label">MD. Used</span>
                <span class="dt-md-metric__value">{{ mdUsed }}</span>
              </div>
              <div class="dt-md-metric mb-0">
                <span class="dt-md-metric__label">MD. Available</span>
                <span class="dt-md-metric__value">{{ mdAvailable }}</span>
              </div>
            </div>
            <div class="avatar-sm flex-shrink-0">
              <span class="avatar-title bg-soft-info text-info rounded-circle fs-4">
                <i class="ri-calendar-check-line" aria-hidden="true"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-sm-flex align-items-center justify-content-between pb-2">
        <div>
          <h4 class="mb-1">Daftar Tiket</h4>
          <p class="text-muted mb-0 small">
            <span v-if="status_val === 'all'">Menampilkan semua tiket.</span>
            <span v-else-if="status_val === 'progress'">Menampilkan tiket yang masih diproses.</span>
            <span v-else>Menampilkan tiket yang sudah ditutup.</span>
            Klik kode tiket untuk melihat timeline.
          </p>
        </div>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="card shadow-sm border-0" id="ticketsList">
        <div class="card-header border-0 bg-light bg-opacity-50 py-3">
          <div class="d-flex flex-wrap align-items-center gap-2">
            <h5 class="card-title mb-0 flex-grow-1">Tiket</h5>
            <div class="flex-shrink-0 d-flex flex-wrap gap-2">
              <button type="button" class="btn btn-outline-success btn-sm" @click="exportToExcelAll">
                <i class="ri-file-excel-line align-bottom me-1"></i> Ekspor Excel
              </button>
              <button type="button" class="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#showModal"
                v-show="level_name != 'ADMINISTRATOR'">
                <i class="ri-add-line align-bottom me-1"></i> Buat Tiket
              </button>
              <!-- <button @click="storeFile">Test upload</button> -->
            </div>
          </div>
        </div>
        <!--end card-body-->
        <div class="card-body pt-0">
          <div class="dt-table-filters rounded-3 border bg-light bg-opacity-50 p-3 mb-3">
            <div class="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-2">
              <span class="small fw-semibold text-uppercase text-muted">Filter tabel</span>
              <div class="d-flex align-items-center gap-2">
                <span v-if="activeFilterCount > 0" class="badge bg-primary rounded-pill">{{ activeFilterCount }}
                  aktif</span>
                <button type="button" class="btn btn-link btn-sm text-decoration-none p-0"
                  @click="resetTableFiltersAndFetch">
                  Reset filter
                </button>
              </div>
            </div>
            <div class="row g-2 align-items-end">
              <div class="col-12 col-sm-6 col-xl" v-show="level_name == 'ADMINISTRATOR'">
                <label class="form-label small text-muted mb-0">Nama user</label>
                <input v-model.trim="filterNamaUser" type="search" class="form-control form-control-sm"
                  placeholder="Cari nama…" autocomplete="off" />
              </div>
              <div class="col-12 col-sm-6 col-xl">
                <label class="form-label small text-muted mb-0">Kode tiket</label>
                <input v-model.trim="filterKode" type="search" class="form-control form-control-sm"
                  placeholder="Cari kode…" autocomplete="off" />
              </div>
              <div class="col-12 col-sm-6 col-xl">
                <label class="form-label small text-muted mb-0">Modul</label>
                <input v-model.trim="filterModul" type="search" class="form-control form-control-sm"
                  placeholder="Nama produk / modul…" autocomplete="off" />
              </div>
              <div class="col-12 col-sm-6 col-xl">
                <label class="form-label small text-muted mb-0">Lokasi</label>
                <input v-model.trim="filterLokasi" type="search" class="form-control form-control-sm"
                  placeholder="Cari lokasi…" autocomplete="off" />
              </div>
              <div class="col-12 col-sm-6 col-xl">
                <label class="form-label small text-muted mb-0">Keluhan</label>
                <input v-model.trim="filterKeluhan" type="search" class="form-control form-control-sm"
                  placeholder="Kata kunci deskripsi…" autocomplete="off" />
              </div>
              <div class="col-12 col-sm-6 col-xl">
                <label class="form-label small text-muted mb-0">Status tiket</label>
                <select v-model="filterStatus" class="form-select form-select-sm">
                  <option value="">Semua status</option>
                  <option value="new">Baru</option>
                  <option value="assign">Assign</option>
                  <option value="progress">Progress</option>
                  <option value="hold">Hold</option>
                  <option value="resolved">Resolved</option>
                  <option value="reopen">Re-open</option>
                  <option value="retest">Re-test</option>
                  <option value="cancelled">Dibatalkan</option>
                  <option value="_other">Selesai / lainnya</option>
                </select>
              </div>
              <div class="col-12 col-sm-auto d-flex align-items-end">
                <button type="button" class="btn btn-primary btn-sm" @click="applyTableFilters">
                  Terapkan filter
                </button>
              </div>
            </div>
            <!-- <p class="text-muted small mb-0 mt-2">
              Filter teks dikirim lewat <strong>query</strong>
              (<code class="small">kode_tiket</code>, <code class="small">deskripsi</code>,
              <code class="small">nama_produk</code>, <code class="small">lokasi</code>); status &amp; nama user di
              <strong>body</strong>. Halaman ini: <strong>{{ datas.length }}</strong> baris · hal.
              <strong>{{ currentPage }}</strong> / <strong>{{ last_page || 1 }}</strong>.
            </p> -->
          </div>
          <div class="table-responsive table-card mb-3  mt-2 p-3">
            <table class="table table-hover table-bordered align-middle table-nowrap mb-0 dt-ticket-table"
              id="ticketTable">
              <thead class="table-light">
                <tr>
                  <th class="sort text-nowrap" data-sort="id">Kode Tiket</th>
                  <th class="sort text-nowrap" data-sort="nama" v-show="level_name == 'ADMINISTRATOR'">Nama User</th>
                  <th class="sort text-nowrap" data-sort="produk">Modul</th>
                  <th class="sort text-nowrap" data-sort="requester">Nama Peminta</th>
                  <th class="sort" data-sort="tasks_name">Keluhan</th>
                  <th class="sort text-nowrap" data-sort="tasks_name">Lokasi</th>
                  <th class="sort text-nowrap" data-sort="create_date">Tanggal Buat</th>
                  <th class="sort text-nowrap" data-sort="closed_date">Tanggal Tutup</th>
                  <th class="sort text-nowrap" data-sort="durasi">Durasi</th>
                  <th class="sort text-nowrap" data-sort="man_days">ManDays</th>
                  <th class="sort text-nowrap" data-sort="priority">Priority</th>
                  <th class="sort text-nowrap" data-sort="status">Status</th>
                  <th class="sort text-nowrap text-center" data-sort="action">Chat</th>
                  <!-- <th class="sort" data-sort="action" v-show="level_name == 'ADMINISTRATOR'">Aksi</th> -->
                </tr>
              </thead>
              <tbody v-if="datas.length > 0" class="list form-check-all">
                <template v-for="item in datas" :key="item.value.aut1 || item.value.kodetiket">
                  <tr>
                    <!-- <td>{{ index + 1 }}</td> -->
                    <td class="id text-start">
                      <a href="#" class="link-primary fw-semibold text-decoration-underline link-offset-2"
                        data-bs-toggle="modal" data-bs-target="#exampleModal"
                        :title="'Timeline: ' + item.value.kodetiket" @click.prevent="showTimeline(item.value.aut1)">{{
                          item.value.kodetiket }}</a>
                    </td>
                    <td class="nama text-start" v-show="level_name == 'ADMINISTRATOR'">
                      {{ item.value.nm_kontak }}
                    </td>
                    <td class="produk text-start text-nowrap">
                      {{ item.value.nama_produk }}
                    </td>
                    <td class="requester text-start text-nowrap">
                      {{ item.value.requester }}
                    </td>
                    <td class="tasks_name text-start dt-cell-deskripsi"
                      :title="item.value.deskripsi ? item.value.deskripsi.replace(/<br\s*\/?>/gi, ' ') : ''">
                      {{ item.value.deskripsi.replace(/<br\s*\?>/gi, '') }}
                    </td>
                    <td class="tasks_name text-start">
                      {{ item.value.lokasi || '—' }}
                    </td>
                    <td class="create_date text-nowrap">{{ item.value.tgl_terima }}</td>
                    <td class="closed_date text-nowrap">{{ item.value.tgl_tutup ?? '—' }}</td>
                    <td class="durasi text-nowrap">{{ hitungDurasi(item.value.tgl_terima, item.value.tgl_tutup,
                      item.value.stat_tiket) }}
                    </td>
                    <td class="man_days text-nowrap">{{ item.value.man_days ?? '—' }}</td>
                    <td class="priority text-nowrap" v-if="item.value.prioritas == 'High'">
                      <span class="badge bg-danger">High</span>
                    </td>
                    <td class="priority text-nowrap" v-else-if="item.value.prioritas == 'Medium'">
                      <span class="badge bg-warning">Medium</span>
                    </td>
                    <td class="priority text-nowrap" v-else-if="item.value.prioritas == 'Low'">
                      <span class="badge bg-success">Low</span>
                    </td>
                    <td class="priority text-nowrap" v-else>
                      <span class="badge bg-secondary">—</span>
                    </td>
                    <td class="status text-nowrap" v-if="item.value.stat_tiket == 'new'">
                      <span class="badge bg-warning text-dark">Baru</span>
                    </td>
                    <td class="status text-nowrap" v-else-if="item.value.stat_tiket == 'assign'">
                      <span class="badge bg-info text-dark">Assign</span>
                    </td>
                    <td class="status text-nowrap" v-else-if="item.value.stat_tiket == 'progress'">
                      <span class="badge bg-primary">Progress</span>
                    </td>
                    <td class="status text-nowrap" v-else-if="item.value.stat_tiket == 'hold'">
                      <span class="badge bg-dark">Hold</span>
                    </td>
                    <td class="status text-nowrap" v-else-if="item.value.stat_tiket == 'resolved'">
                      <span class="badge bg-success">Resolved</span>
                    </td>
                    <td class="status text-nowrap" v-else-if="item.value.stat_tiket == 'reopen'">
                      <span class="badge bg-danger">Re-Open</span>
                    </td>
                    <td class="status text-nowrap" v-else-if="item.value.stat_tiket == 'retest'">
                      <span class="badge bg-secondary">Re-Test</span>
                    </td>
                    <td class="status text-nowrap" v-else-if="item.value.stat_tiket == 'cancelled'">
                      <span class="badge bg-danger">Dibatalkan</span>
                    </td>
                    <td class="status text-nowrap" v-else>
                      <span class="badge bg-success">Selesai</span>
                    </td>
                    <td class="text-center">
                      <button type="button" class="btn btn-soft-primary btn-sm position-relative"
                        title="Buka percakapan" :aria-label="'Chat tiket ' + item.value.kodetiket" @click.prevent="
                          showMessage(
                            item.value.aut1,
                            item.value.stat_tiket,
                            item.value.email
                          )">
                        <i class="ri-chat-1-fill" aria-hidden="true"></i>
                        <span
                          class="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle"
                          v-if="isPresent(item.value.kodetiket)">
                          <span class="visually-hidden">Pesan belum dibaca</span>
                        </span>
                      </button>
                    </td>
                    <!-- <td>
                    <button class="btn btn-danger waves-effect waves-light" @click.prevent="hapus(item.value.aut1)">
                      <i class="ri-delete-bin-5-line"></i>
                    </button>
                  </td> -->
                  </tr>
                </template>
              </tbody>
              <tbody v-else>
                <tr>
                  <td :colspan="level_name == 'ADMINISTRATOR' ? 13 : 12" class="py-5 text-center text-muted col">
                    <template v-if="loadingList">
                      <div class="spinner-border spinner-border-sm text-primary mb-2" role="status">
                        <span class="visually-hidden">Memuat…</span>
                      </div>
                      <span class="d-block fw-medium">Memuat tiket…</span>
                    </template>
                    <template v-else-if="activeFilterCount > 0">
                      <i class="ri-filter-off-line fs-1 d-block mb-2 opacity-50" aria-hidden="true"></i>
                      <span class="fw-medium">Tidak ada tiket yang cocok dengan filter</span>
                      <span class="d-block small mt-1">Sesuaikan filter lalu klik Terapkan, atau Reset filter.</span>
                    </template>
                    <template v-else>
                      <i class="ri-inbox-line fs-1 d-block mb-2 opacity-50" aria-hidden="true"></i>
                      <span class="fw-medium">Belum ada tiket</span>
                      <span class="d-block small mt-1">Ubah filter ringkasan di atas atau buat tiket baru.</span>
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-3 pt-2 border-top">
            <p class="text-muted small mb-0">
              Halaman <strong>{{ currentPage }}</strong> dari <strong>{{ last_page || 1 }}</strong>
              <span v-if="loadingList" class="ms-2 text-primary">· memuat…</span>
            </p>
            <div class="pagination-wrap hstack gap-2">
              <button type="button" class="btn btn-outline-secondary btn-sm pagination-prev"
                @click="onClickPreviousPage" :disabled="isInFirstPage || loadingList">
                <i class="ri-arrow-left-s-line align-middle me-1"></i> Sebelumnya
              </button>
              <span class="badge bg-light text-dark border px-3 py-2">{{ currentPage }}</span>
              <button type="button" class="btn btn-outline-secondary btn-sm pagination-next" @click="onClickNextPage"
                :disabled="isInLastPage || loadingList">
                Berikutnya <i class="ri-arrow-right-s-line align-middle ms-1"></i>
              </button>
            </div>
          </div>
        </div>
        <!--end card-body-->
      </div>
      <!--end card-->
    </div>
    <!--end col-->
  </div>
  <div class="modal fade zoomIn" id="showModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content border-0">
        <div class="modal-header p-3 bg-soft-info">
          <h5 class="modal-title" id="exampleModalLabel" v-show="level_name != 'ADMINISTRATOR'">Buat Tiket</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"></button>
        </div>
        <form @submit.prevent="submitForm" ref="fTiket">
          <div class="modal-body">
            <div class="row g-3">
              <!-- <div class="col-lg-12">
                <div>
                  <label for="tasksTitle-field" class="form-label"
                    >Kategori</label
                  >
                  <select class="form-control" v-model="selectedKategori">
                    <option value="" selected disabled>Pilih Kategori</option>
                    <option value="1">Pertanyaan Umum</option>
                    <option value="2">Berhubungan dengan Proyek</option>
                  </select>
                </div>
              </div> -->
              <div class="col-lg-12">
                <div>
                  <label class="form-label">Nama User</label>
                  <input type="text" class="form-control" v-model="nama" readonly />
                </div>
              </div>
              <div class="col-lg-12">
                <div>
                  <label class="form-label">Perusahaan</label>
                  <input type="text" class="form-control" v-model="company" readonly />
                </div>
              </div>
              <div class="col-lg-12">
                <div>
                  <label class="form-label">Nama Peminta (Requester)</label>
                  <input type="text" class="form-control" v-model="requester" />
                </div>
              </div>
              <div class="col-lg-12">
                <div>
                  <label class="form-label">Lokasi</label>
                  <input type="text" class="form-control" v-model="lokasi" />
                </div>
              </div>

              <!-- <div class="col-lg-12">
                <div>
                  <label class="form-label">Produk</label>
                  <input type="text" class="form-control" v-model="produk" readonly/>
                </div>
              </div> -->
              <div class="col-lg-12">
                <div>
                  <label class="form-label">Produk</label>
                  <select class="form-select" v-model="selectedProduk" @change="produkChange($event)">
                    <option value="" selected disabled>Pilih Produk</option>
                    <option v-for="prod in listOfProduk" :key="prod.autono" :value="prod.id_produk"
                      :data-proyek="prod.id_proyek">
                      {{ prod.nama_kategori }}
                    </option>
                    <option value="lainnya">Lainnya</option>
                  </select>
                </div>
              </div>

              <div class="col-lg-12">
                <div>
                  <label class="form-label">Modul</label>
                  <select class="form-select" v-model="selectedModule">
                    <option value="" selected disabled>Pilih Modul</option>
                    <option v-for="mod in module" :key="mod.autono" :value="mod.autono" v-html="mod.nama"></option>
                  </select>
                </div>
              </div>

              <!-- <div class="col-lg-12">
                <div>
                  <label class="form-label">Modul</label>
                  <input type="text" class="form-control" v-model="modul" />
                </div>
              </div> -->

              <div class="col-lg-12" v-show="selectedProduk == 'lainnya'">
                <div>
                  <label for="" class="form-label"> Nama Produk </label>
                  <input type="text" class="form-control" v-model="lainnya" />
                </div>
              </div>

              <div class="col-lg-12">
                <div>
                  <label class="form-label">Prioritas</label>
                  <select class="form-select" v-model="selectedPrioritas">
                    <option value="" selected disabled>Pilih Prioritas</option>
                    <option v-for="prio in prioritasList" :key="prio.autono" :value="prio.autono" v-html="prio.nama_prioritas"></option>
                  </select>
                </div>
              </div>

              <div class="col-lg-12">
                <div>
                  <label for="tasksTitle-field" class="form-label">Deskripsi Keluhan</label>
                  <textarea class="form-control" v-model="keluhan"> </textarea>
                </div>
              </div>

              <div class="col-md-12">
                <label class="form-label">Lampiran File</label>
                <input type="file" class="form-control" ref="lampiran" @change="handleFileChange" />
                <code>Ukuran Maksimal <strong>100 Mb</strong></code>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="hstack gap-2 justify-content-end">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">
                Batal
              </button>
              <button type="submit" class="btn btn-success" id="add-btn" :disabled="loading">
                Buat Tiket
              </button>
              <!-- <button type="button" class="btn btn-success" id="edit-btn">
                Update
              </button> -->
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import firebase from "@/services/firebaseInit";
import eventBus from "@/event-bus";
export default {
  data() {
    return {
      company: "",
      requester: "",
      lokasi: "",
      modul: "",
      produk: "",
      listOfProduk: [],
      selectedKategori: {},
      selectedProduk: {},
      id_proyek: "",
      keluhan: "",
      maxVisibleButtons: 3,
      totalPages: "",
      currentPage: 1,
      datas: [],
      last_page: 1,
      loadingList: false,
      fetchSeq: 0,
      lainnya: null,
      level_name: localStorage.getItem("level_name"),
      entitas: localStorage.getItem("entitas"),
      lampiran: null,
      total_tiket: 0,
      pending_tiket: 0,
      closed_tiket: 0,
      mdBillable: 0,
      mdUsed: 0,
      loading: false,
      pt: null,
      status_val: "all",
      op: {
        kodetiket: "",
        nama_produk: "",
        tgl_buat: "",
        deskripsi: "",
        note: "",
        file: "",
        nama_file: "",
        tgl_tutup: "",
        jawaban: "",
        pertanyaan: "",
        status: "",
      },
      pm: [],
      tek: [],
      loadingApi: false,
      tiketSeen: [],
      notif: localStorage.getItem("notif-key"),
      pmFile: null,
      filterKode: "",
      filterModul: "",
      filterLokasi: "",
      filterKeluhan: "",
      filterStatus: "",
      filterNamaUser: "",
      /** Filter yang sudah ditekan "Terapkan" — dipakai untuk list & request API. */
      appliedFilter: {
        kode: "",
        modul: "",
        lokasi: "",
        keluhan: "",
        status: "",
        namaUser: "",
      },
      nama: localStorage.getItem("nama"),
      module: [],
      selectedModule: "",
      prioritasList: [],
      selectedPrioritas: "",
    };
  },
  methods: {
    resetTableFilters() {
      this.filterKode = "";
      this.filterModul = "";
      this.filterLokasi = "";
      this.filterKeluhan = "";
      this.filterStatus = "";
      this.filterNamaUser = "";
      this.appliedFilter = {
        kode: "",
        modul: "",
        lokasi: "",
        keluhan: "",
        status: "",
        namaUser: "",
      };
    },
    /** Hapus filter lalu muat ulang halaman 1 dari API. */
    resetTableFiltersAndFetch() {
      this.resetTableFilters();
      this.fetchTiketPage(1);
    },
    /** Salin nilai form ke appliedFilter, lalu fetch halaman 1. */
    applyTableFilters() {
      this.appliedFilter = {
        kode: String(this.filterKode || "").trim(),
        modul: String(this.filterModul || "").trim(),
        lokasi: String(this.filterLokasi || "").trim(),
        keluhan: String(this.filterKeluhan || "").trim(),
        status: String(this.filterStatus || "").trim(),
        namaUser:
          this.level_name === "ADMINISTRATOR"
            ? String(this.filterNamaUser || "").trim()
            : "",
      };
      this.fetchTiketPage(1);
    },
    /**
     * Query string sesuai CustomerController::applySearchFilter + page.
     * Field: kode_tiket, deskripsi, nama_produk, lokasi, stat_tiket (opsional).
     */
    tiketStatusQueryString(page) {
      const p = Math.max(1, Number(page) || 1);
      const f = this.appliedFilter || {};
      const q = new URLSearchParams();
      q.set("page", String(p));
      q.set("kode_tiket", String(f.kode || "").trim());
      q.set("deskripsi", String(f.keluhan || "").trim());
      q.set("nama_produk", String(f.modul || "").trim());
      q.set("lokasi", String(f.lokasi || "").trim());
      q.set("stat_tiket", String(f.status || "").trim());
      if (this.level_name === "ADMINISTRATOR") {
        q.set("nm_kontak", String(f.namaUser || "").trim());
      }
      return q.toString();
    },
    /**
     * Body POST sesuai CustomerController::tiketStatus.
     * status = tab ringkasan: all | progress | closed
     */
    tiketStatusRequestBody() {
      return {
        id: localStorage.getItem("id"),
        level_name: this.level_name,
        entitas: this.entitas,
        status: this.status_val || "all",
      };
    },
    isPresent(string) {
      if (this.notif != null) {
        let parsed = JSON.parse(this.notif);
        return parsed.includes(string);
      }
    },
    exportToExcelAll() {
      const dataAll = [
        [
          "Kode Tiket",
          "Nama User",
          "Produk",
          "Modul",
          "Keluhan",
          "Lokasi",
          "Tanggal Buat Tiket",
          "Tanggal Tutup Tiket",
          "Durasi",
          "Status",
        ],
      ];

      axios
        .post("https://api.vitech.asia/api/tiketstatusall", {
          id: localStorage.getItem("id"),
          level_name: this.level_name,
          entitas: this.entitas,
          status: this.status_val,
        })
        .then((res) => {
          res.data.data.forEach((element) => {
            let newArrs = [
              element.kodetiket,
              element.nm_kontak,
              element.nama_kategori,
              element.nama_produk,
              element.deskripsi.replace(/<br\s*\/?>/gi, ""),
              element.lokasi,
              element.tgl_terima,
              element.tgl_tutup,
              this.hitungDurasi(
                element.tgl_terima,
                element.tgl_tutup,
                element.stat_tiket
              ),
              element.stat_tiket,
            ];
            dataAll.push(newArrs);
          });

          const wsall = XLSX.utils.aoa_to_sheet(dataAll);
          const wball = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wball, wsall, "Sheet1");

          // Save the Excel file
          XLSX.writeFile(wball, "report_all.xlsx");
        });
    },
    hapus(autono) {
      try {
        axios
          .post("https://api.vitech.asia/api/hapustiket", {
            id: autono,
          })
          .then((res) => {
            Swal.fire({
              icon: "success",
              title: "Berhasil!",
              text: res.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
            window.location.reload();
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
    },
    getModule() {
      try {
        axios
          .post("https://api.vitech.asia/api/customermodule", {
            entitas: localStorage.getItem("entitas"),
          })
          .then((res) => {
            this.module = res.data.data;
            console.log(this.module);
          });
      } catch (error) {
        console.log(error);
      }
    },
    getProduk() {
      try {
        axios
          .post("https://api.vitech.asia/api/customerproduk", {
            entitas: localStorage.getItem("entitas"),
          })
          .then((res) => {
            res.data.forEach((element) => {
              this.company = element.nama_instansi;
              this.produk = element.nama_kategori;
              this.pt = element.id_entitas;
              this.id_proyek = element.id_proyek;
            });
            this.listOfProduk = res.data;
            // this.company = res.data.instansi.nama_instansi;
            // this.pt = res.data.instansi.id_entitas;
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
    },
    getPrioritas() {
      try {
        axios
          .get("https://api.vitech.asia/api/getPrioritas")
          .then((res) => {
            this.prioritasList = res.data.data;
            console.log(this.prioritasList);
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
    },
    /** Muat satu halaman dari API; selalu mengganti `datas` (bukan append). */
    fetchTiketPage(page) {
      const p = Math.max(1, Number(page) || 1);
      const seq = ++this.fetchSeq;
      this.loadingList = true;
      this.currentPage = p;

      axios
        .post(
          "https://api.vitech.asia/api/tiketstatus?" + this.tiketStatusQueryString(p),
          this.tiketStatusRequestBody()
        )
        .then((res) => {
          // Abaikan respons lama jika user sudah pindah halaman / filter lagi.
          if (seq !== this.fetchSeq) return;

          const payload = res.data && res.data.data ? res.data.data : {};
          const apiPage = Number(payload.current_page);
          const apiLast = Number(payload.last_page);

          this.currentPage = Number.isFinite(apiPage) && apiPage > 0 ? apiPage : p;
          this.last_page = Number.isFinite(apiLast) && apiLast > 0 ? apiLast : 1;

          const rows = Array.isArray(payload.data) ? payload.data : [];
          this.datas = rows.map((item) => ({ index: item, value: item }));
        })
        .catch((error) => {
          if (seq !== this.fetchSeq) return;
          console.log(error);
          this.datas = [];
          this.last_page = 1;
        })
        .finally(() => {
          if (seq === this.fetchSeq) {
            this.loadingList = false;
          }
        });
    },
    getTiket() {
      this.fetchTiketPage(this.currentPage);
    },
    produkChange(event) {
      var options = event.target.options;
      if (options.selectedIndex > -1) {
        var name = options[options.selectedIndex].getAttribute("data-proyek");
        this.id_proyek = name;
        console.log(this.id_proyek);
        console.log(this.selectedProduk);
      }
    },
    submitForm() {
      this.loading = true;
      try {
        axios
          .post(
            "https://api.vitech.asia/api/customerstore",
            {
              id: localStorage.getItem("id"),
              id_proyek: this.id_proyek ?? "15",
              id_produk: this.selectedProduk == "lainnya" ? this.lainnya : this.selectedProduk,
              modul: this.selectedModule,
              keluhan: this.keluhan,
              foto: this.lampiran,
              email: localStorage.getItem("email"),
              company: this.company,
              nama: localStorage.getItem("nama"),
              entitas: this.pt,
              lokasi: this.lokasi,
              requester: this.requester,
              prioritas: this.selectedPrioritas,
            },
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((res) => {
            this.loading = false;
            this.$refs.fTiket.reset();
            Swal.fire({
              icon: "success",
              title: "Berhasil!",
              text: res.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
            window.location.reload();
          })
          .catch((err) => {
            this.loading = false;
            Swal.fire({
              icon: "error",
              title: "Gagal!",
              text: err.response.data.data ?? "size harus kurang dari 1 mb",
              showConfirmButton: false,
              timer: 1500,
            });
          });
      } catch (error) {
        console.log(error);
      }
    },
    hitungDurasi(awal, akhir, status) {
      // Menghitung selisih dalam milidetik
      if (status == "closed" || status == "cancelled" || status == "hold") {
        let selisihMillis = new Date(akhir) - new Date(awal);

        const detik = Math.floor(selisihMillis / 1000);
        const menit = Math.floor(detik / 60);
        const jam = Math.floor(menit / 60);
        const hari = Math.floor(jam / 24);

        // Menghitung sisa jam, menit, dan detik setelah dihitung hari
        const sisaJam = jam % 24;
        const sisaMenit = menit % 60;
        const sisaDetik = detik % 60;

        if (hari > 0) {
          return `${hari} hari ${sisaJam} jam ${sisaMenit} menit`;
        } else if (jam > 0) {
          return `${sisaJam} jam ${sisaMenit} menit`;
        } else if (menit > 0) {
          return `${sisaMenit} menit ${sisaDetik} detik`;
        } else {
          return `${sisaDetik} detik`;
        }
      } else if (status == "progress" && akhir != null) {
        // let sum = new Date(awal) - new Date(akhir);
        // console.log(sum);
        let selisihMillis = new Date() - new Date(akhir);

        const detik = Math.floor(selisihMillis / 1000);
        const menit = Math.floor(detik / 60);
        const jam = Math.floor(menit / 60);
        const hari = Math.floor(jam / 24);

        // Menghitung sisa jam, menit, dan detik setelah dihitung hari
        const sisaJam = jam % 24;
        const sisaMenit = menit % 60;
        const sisaDetik = detik % 60;

        if (hari > 0) {
          return `${hari} hari ${sisaJam} jam ${sisaMenit} menit`;
        } else if (jam > 0) {
          return `${sisaJam} jam ${sisaMenit} menit`;
        } else if (menit > 0) {
          return `${sisaMenit} menit ${sisaDetik} detik`;
        } else {
          return `${sisaDetik} detik`;
        }
      } else {
        let selisihMillis = new Date() - new Date(awal);

        const detik = Math.floor(selisihMillis / 1000);
        const menit = Math.floor(detik / 60);
        const jam = Math.floor(menit / 60);
        const hari = Math.floor(jam / 24);

        // Menghitung sisa jam, menit, dan detik setelah dihitung hari
        const sisaJam = jam % 24;
        const sisaMenit = menit % 60;
        const sisaDetik = detik % 60;
        if (hari > 0) {
          return `${hari} hari ${sisaJam} jam ${sisaMenit} menit`;
        } else if (jam > 0) {
          return `${sisaJam} jam ${sisaMenit} menit`;
        } else if (menit > 0) {
          return `${sisaMenit} menit ${sisaDetik} detik`;
        } else {
          return `${sisaDetik} detik`;
        }
      }
    },
    onClickPage(page) {
      this.fetchTiketPage(page);
    },
    onClickNextPage() {
      if (this.loadingList) return;
      const cur = Number(this.currentPage) || 1;
      const last = Number(this.last_page) || 1;
      if (cur < last) {
        this.fetchTiketPage(cur + 1);
      }
    },
    onClickPreviousPage() {
      if (this.loadingList) return;
      const cur = Number(this.currentPage) || 1;
      if (cur > 1) {
        this.fetchTiketPage(cur - 1);
      }
    },
    isPageActive(page) {
      return Number(this.currentPage) === Number(page);
    },
    onPageChange(page) {
      this.fetchTiketPage(page);
    },
    showMessage(kdtiket, stt, email) {
      window.location.href =
        "/message?q=" +
        window.btoa(kdtiket) +
        "&status=" +
        window.btoa(stt) +
        "&email=" +
        window.btoa(email);
    },
    handleFileChange(event) {
      // Access the selected file from the event
      this.lampiran = event.target.files[0];
    },
    showAll(val) {
      this.resetTableFilters();
      this.status_val = val;
      this.fetchTiketPage(1);
    },
    showTimeline(autono) {
      this.loadingApi = true;
      this.pm = [];
      this.tek = [];
      this.pmFile = "";
      try {
        axios
          .post("https://api.vitech.asia/api/showtimeline", {
            autono: autono,
          })
          .then((res) => {
            //console.log(res);
            //op
            this.op.nama_produk = res.data.op.nama_produk;
            this.op.tgl_buat = res.data.op.created_on;
            this.op.tgl_tutup = res.data.op.tgl_tutup;
            this.op.deskripsi = res.data.op.deskripsi.replace(
              /<br\s*\/?>/gi,
              "\n"
            );
            this.op.file = res.data.op.file;
            this.op.nama_file = res.data.op.nama_file;
            this.op.kodetiket = res.data.op.kodetiket;
            this.op.pertanyaan = res.data.op.pertanyaan;
            this.op.jawaban = res.data.op.jawaban;
            this.op.status = res.data.op.status;
            //pm
            // this.pm.tgl_penugasan_awal = res.data.pm.data.tgl_penugasan_awal;
            // this.pm.tgl_penugasan_akhir = res.data.pm.data.tgl_penugasan_akhir;
            // this.pm.catatan = res.data.pm.data.catatan;
            // let splited = res.data.pm.data.nm_pegawai.split(",", 2);
            // this.pm.nama = splited;
            res.data.pm.data.forEach((el) => {
              this.pm.push(el);
            });

            res.data.pm.file.forEach((el) => {
              this.pmFile = el.nama_file;
            });
            //tek
            res.data.tek.data.forEach((el) => {
              this.tek.push(el);
            });
            this.loadingApi = false;
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
    },
    splitStringFromArray(string) {
      if (string !== null) {
        const resultArr = string.split(",");
        // const newArray = resultArr.map((element) => {
        //   // Menggunakan replace untuk menghapus underscore dari setiap elemen
        //   return element.replace(/_/g, " ");
        // });
        return resultArr;
      }
    },
    splitString(string) {
      if (string !== null) {
        return string.replace(/_/g, " ");
      }
    },
    ambilExtension(string) {
      if (string !== null) {
        const resArr = string.split(".");
        const extension = resArr[resArr.length - 1];
        return extension;
      }
    },
    getStatus() {
      try {
        axios
          .post("https://api.vitech.asia/api/getStatus", {
            id_kontak: localStorage.getItem("id"),
          })
          .then((res) => {
            res.data.data.forEach((el) => {
              this.tiketSeen.push(el.kodetiket);
            });
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
    },
    storeFile() { },
    mandaysRequestBody() {
      return {
        entitas: localStorage.getItem("entitas"),
      };
    },
    sumMandaysRequestBody() {
      return {
        id_kontak: localStorage.getItem("id"),
      };
    },
    parseBillableMandays(payload) {
      if (payload == null) return 0;
      if (typeof payload === "number" && Number.isFinite(payload)) return payload;
      if (typeof payload === "string" && payload !== "" && !Number.isNaN(Number(payload))) {
        return Number(payload);
      }
      if (Array.isArray(payload)) {
        if (payload.length === 0) return 0;
        if (typeof payload[0] === "number") return Number(payload[0]) || 0;
        return payload.reduce((sum, row) => {
          const value = Number(
            row?.billable ??
              row?.billable_mandays ??
              row?.mandays ??
              row?.total ??
              row?.total_billable ??
              0
          );
          return sum + (Number.isFinite(value) ? value : 0);
        }, 0);
      }
      if (typeof payload === "object") {
        const value = Number(
          payload.billable ??
            payload.billable_mandays ??
            payload.total ??
            payload.total_billable ??
            payload.mandays ??
            0
        );
        return Number.isFinite(value) ? value : 0;
      }
      return 0;
    },
    getMandaysSummary() {
      const body = this.mandaysRequestBody();
      const sumBody = this.sumMandaysRequestBody();
      axios
        .post("https://api.vitech.asia/api/billableMandays", body)
        .then((res) => {
          const payload = res.data?.data ?? res.data;
          console.log('billableMandays', payload);
          this.mdBillable = this.parseBillableMandays(payload);
        })
        .catch((error) => {
          console.log(error);
        });
      axios
        .post("https://api.vitech.asia/api/sumMandays", sumBody)
        .then((res) => {
          const payload = res.data?.data ?? res.data;
          console.log('sumMandays', payload);
          const used = Number(payload?.total_billable ?? 0);
          this.mdUsed = Number.isFinite(used) ? used : 0;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  created() {
    this.getModule();
    this.getProduk();
    this.getTiket();
    this.getStatus();
    this.getPrioritas();
    this.getMandaysSummary();
    try {
      axios
        .post("https://api.vitech.asia/api/tiketcount", {
          id: localStorage.getItem("id"),
          level_name: this.level_name,
          entitas: localStorage.getItem("entitas"),
        })
        .then((res) => {
          this.total_tiket = res.data.data.total;
          this.pending_tiket = res.data.data.progres;
          this.closed_tiket = res.data.data.close;
        });
    } catch (error) {
      console.log(error);
    }
  },
  mounted() {
    window.addEventListener("notif-change", (event) => {
      this.notif = event.detail.storage;
    });
  },
  computed: {
    startPage() {
      if (this.currentPage === 1) {
        return 1;
      }

      if (this.currentPage === this.totalPages) {
        return this.totalPages - this.maxVisibleButtons;
      }

      // When inbetween
      return this.currentPage - 1;
    },
    pages() {
      const range = [];

      for (
        let i = this.startPage;
        i <= Math.min(this.startPage, this.totalPages);
        i++
      ) {
        range.push({
          name: i,
          isDisabled: i === this.currentPage,
        });
      }

      return range;
    },
    isInFirstPage() {
      return Number(this.currentPage) <= 1;
    },
    isInLastPage() {
      return Number(this.currentPage) >= (Number(this.last_page) || 1);
    },
    activeFilterCount() {
      const f = this.appliedFilter || {};
      let n = 0;
      if (String(f.kode || "").trim()) n++;
      if (String(f.modul || "").trim()) n++;
      if (String(f.lokasi || "").trim()) n++;
      if (String(f.keluhan || "").trim()) n++;
      if (String(f.status || "").trim()) n++;
      if (this.level_name === "ADMINISTRATOR" && String(f.namaUser || "").trim()) {
        n++;
      }
      return n;
    },
    mdAvailable() {
      const available = Number(this.mdBillable) - Number(this.mdUsed);
      return Number.isFinite(available) ? available : 0;
    },
  },
};
</script>
<style scoped>
.pagination {
  list-style-type: none;
}

.pagination-item {
  display: inline-block;
}

.active {
  background-color: #4aae9b;
  color: #ffffff;
}

#ticketTable thead th {
  vertical-align: middle;
  font-weight: 600;
  font-size: 0.8125rem;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  color: var(--vz-secondary-color, #6c757d);
}

.dt-cell-deskripsi {
  max-width: 14rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (min-width: 1200px) {
  .dt-cell-deskripsi {
    max-width: 22rem;
  }
}

.dt-filter-card {
  cursor: pointer;
  border: 1px solid rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.2s ease, transform 0.2s ease, border-color 0.2s ease;
}

.dt-filter-card:hover {
  box-shadow: 0 0.35rem 1rem rgba(15, 34, 58, 0.08);
  transform: translateY(-2px);
}

.dt-filter-card:focus-visible {
  outline: 2px solid var(--vz-primary, #405189);
  outline-offset: 2px;
}

.dt-filter-card--active {
  border-color: var(--vz-primary, #405189) !important;
  box-shadow: 0 0.25rem 0.75rem rgba(64, 81, 137, 0.15);
}

.dt-md-metric {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.5rem;
}

.dt-md-metric__label {
  font-size: 0.8125rem;
  color: var(--vz-secondary-color, #6c757d);
}

.dt-md-metric__value {
  font-size: 1.125rem;
  font-weight: 600;
  font-family: var(--vz-font-secondary, inherit);
  color: var(--vz-body-color, #212529);
}

/* —— Timeline modal (kartu & konten) —— */
.tl-timeline-root .tl-card {
  position: relative;
  z-index: 2;
}

.tl-card-header {
  border-radius: 0.5rem 0.5rem 0 0;
}

.tl-card-header--start {
  background: linear-gradient(135deg, rgba(64, 81, 137, 0.1) 0%, rgba(64, 81, 137, 0.02) 100%);
}

.tl-card-header--assign {
  background: linear-gradient(135deg, rgba(13, 202, 240, 0.12) 0%, rgba(13, 110, 253, 0.04) 100%);
}

.tl-card-header--tech {
  background: linear-gradient(135deg, rgba(25, 135, 84, 0.1) 0%, rgba(32, 201, 151, 0.05) 100%);
}

.tl-step-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.65rem;
  font-size: 1.25rem;
  flex-shrink: 0;
  box-shadow: 0 0.15rem 0.4rem rgba(0, 0, 0, 0.12);
}

.tl-badge-step {
  display: block;
  font-size: 0.6875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 600;
  color: #6c757d;
  margin-bottom: 0.125rem;
}

.tl-meta-label {
  display: block;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-weight: 600;
  color: #878a99;
  margin-bottom: 0.25rem;
}

.tl-meta-grid .tl-meta-label {
  margin-bottom: 0.2rem;
}

.tl-desc {
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.55;
}

.tl-catatan {
  word-break: break-word;
  line-height: 1.5;
}

.tl-catatan :deep(p) {
  margin-bottom: 0.5rem;
}

.tl-catatan :deep(p:last-child) {
  margin-bottom: 0;
}

.tl-thumb-link {
  display: block;
  border-radius: 0.5rem;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.tl-thumb-link:hover {
  box-shadow: 0 0.35rem 1rem rgba(15, 34, 58, 0.12);
  transform: translateY(-1px);
}

.tl-thumb {
  max-height: 220px;
  width: 100%;
  object-fit: contain;
  background: #fff;
}

.tl-file-link {
  display: inline-block;
  padding: 0.25rem;
  border-radius: 0.35rem;
  transition: background-color 0.15s ease, transform 0.15s ease;
}

.tl-file-link:hover {
  background: rgba(64, 81, 137, 0.08);
  transform: scale(1.03);
}

.tl-file-icon {
  max-height: 52px;
  width: auto;
  display: block;
}

.tl-video {
  max-height: 240px;
  background: #000;
}

.tl-assign-inner {
  box-shadow: 0 0.08rem 0.35rem rgba(15, 34, 58, 0.06);
}

.tl-card-closed .tl-desc {
  font-size: 0.9375rem;
}

/* The actual timeline (the vertical ruler) */
.main-timeline-4 {
  position: relative;
}

/* The actual timeline (the vertical ruler) */
.main-timeline-4::after {
  content: "";
  position: absolute;
  width: 3px;
  background-color: #bbb;
  top: 0;
  bottom: 0;
  left: 50%;
  margin-left: -3px;
}

/* Container around content */
.timeline-4 {
  position: relative;
  background-color: inherit;
  width: 50%;
}

/* The circles on the timeline */
.timeline-4::after {
  content: "";
  position: absolute;
  width: 25px;
  height: 25px;
  right: -11px;
  background-color: #bbb;
  top: 15px;
  border-radius: 50%;
  z-index: 1;
}

/* Place the container to the left */
.left-4 {
  padding: 0px 40px 20px 0px;
  left: 0;
  color: #000;
}

/* Place the container to the right */
.right-4 {
  padding: 0px 0px 20px 40px;
  left: 50%;
  color: #000;
}

/* Add arrows to the left container (pointing right) */
.left-4::before {
  content: " ";
  position: absolute;
  top: 18px;
  z-index: 1;
  right: 30px;
  border: medium solid rgba(37, 117, 252, 1);
  border-width: 10px 0 10px 10px;
  border-color: transparent transparent transparent rgba(37, 117, 252, 1);
}

/* Add arrows to the right container (pointing left) */
.right-4::before {
  content: " ";
  position: absolute;
  top: 18px;
  z-index: 1;
  left: 30px;
  border: medium solid rgba(245, 87, 108, 1);
  border-width: 10px 10px 10px 0;
  border-color: transparent rgba(245, 87, 108, 1) transparent transparent;
}

/* Fix the circle for containers on the right side */
.right-4::after {
  left: -14px;
}

/* Media queries - Responsive timeline on screens less than 600px wide */
@media screen and (max-width: 600px) {

  /* Place the timelime to the left */
  .main-timeline-4::after {
    left: 31px;
  }

  /* Full-width containers */
  .timeline-4 {
    width: 100%;
    padding-left: 70px;
    padding-right: 25px;
  }

  /* Make sure that all arrows are pointing leftwards */
  .timeline-4::before {
    left: 60px;
    border: medium solid white;
    border-width: 10px 10px 10px 0;
    border-color: transparent white transparent transparent;
  }

  /* Make sure all circles are at the same spot */
  .left-4::after,
  .right-4::after {
    left: 18px;
  }

  .left-4::before {
    right: auto;
  }

  /* Make all right containers behave like the left ones */
  .right-4 {
    left: 0%;
  }

  .iconClass {
    position: relative;
  }

  .iconClass span {
    position: absolute;
    top: 0px;
    right: 0px;
    display: block;
  }
}
</style>
